const namespace = 'IMPORTS';

export const REQUEST_DETAIL = `${namespace}/REQUEST_DETAIL`;
export const RECEIVE_SUCCESS = `${namespace}/RECEIVE_SUCCESS`;
export const RECEIVE_FAILURE = `${namespace}/RECEIVE_FAILURE`;